module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/hero-mobile-5d988b31103cb4a01ef46dadc7b8629e.webp";